import React, { useEffect, useRef, useState } from 'react';
// import LogoImg from '../assets/BWE_logo.webp'
import LogoImg from '../assets/BWECapitalLogo.png'
import { GrLocation } from "react-icons/gr";
import { MdMailOutline, MdOutlinePhone } from "react-icons/md";
import { FaFacebookF, FaTwitter, FaPinterestP, FaLinkedinIn } from "react-icons/fa";
import { CgMenuRightAlt, CgClose } from "react-icons/cg";

const Sidebar = () => {
  const lastScrollY = useRef(0);
  const [activeSection, setActiveSection] = useState('');
  const [scrollDir, setScrollDir] = useState('down');
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const sections = document.querySelectorAll('section');

    //  Responsive threshold setup
    const screenWidth = window.innerWidth;
    let thresholds;
    if (screenWidth >= 1499) {
      // Desktop
      thresholds = [0.6, 0.6];
    } else if (screenWidth >= 1277) {
      // Desktop
      thresholds = [0.5, 0.6];
    } else if (screenWidth >= 600) {
      // Tab
      thresholds = [0.1, 0.2];
    } else {
      // Mobile
      thresholds = [0.3, 0.4];
    }

    // Track scroll direction
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        setScrollDir('down');
      } else {
        setScrollDir('up');
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        const intersectRatio = entry.intersectionRatio;

        if (entry.isIntersecting) {
          if (scrollDir === 'down' && intersectRatio >= thresholds[1]) {
            setActiveSection(id);
          }

          if (scrollDir === 'up' && intersectRatio >= thresholds[0]) {
            setActiveSection(id);
          }
        }
      });
    }, {
      threshold: thresholds,
    });

    // Start observing
    sections.forEach((section) => observer.observe(section));

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [scrollDir]);

  return (
    <div className='nav-dash-bar-menus'>
      <div className='mobile-menu'>
        <div className="mbl-menu-header">
          <div className='mbl-menu-logo'>
            <img src={LogoImg} alt='img' />
          </div>
          <div className='mbl-menu-btn'>
            <button
              style={{ color: "#000" }}
              type="button"
              id="btn-menu"
              onClick={toggleMenu}
              aria-expanded={menuOpen}
              aria-controls="the-menu"
              aria-label="Toggle menu"
            >
              {menuOpen ? <CgClose /> : <CgMenuRightAlt />}
            </button>
          </div>

          <div
            id="the-menu"
            className={`mobile-menu-dropdown ${menuOpen ? 'open' : ''}`}
          >
            {/* <ul>
              <li><a href="#home" onClick={() => setMenuOpen(false)}>Home</a></li>
              <li><a href="#about" onClick={() => setMenuOpen(false)}>About</a></li>
              <li><a href="#careers" onClick={() => setMenuOpen(false)}>Careers</a></li>
              <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
            </ul> */}
            <ul>
              <li><a href="#home" onClick={() => setMenuOpen(false)}>Home</a></li>
              <li><a href="#about" onClick={() => setMenuOpen(false)}>About Us</a></li>
              <li><a href="#productsAndServices" onClick={() => setMenuOpen(false)}>Products & Services</a></li>
              <li><a href="#solutions" onClick={() => setMenuOpen(false)}>Solutions</a></li>
              <li><a href="#pricing" onClick={() => setMenuOpen(false)}>Pricing</a></li>
              <li><a href="#resources" onClick={() => setMenuOpen(false)}>Resources</a></li>
              <li><a href="#securityAndCompliance" onClick={() => setMenuOpen(false)}>Security & Compliance</a></li>
              <li><a href="#ai" onClick={() => setMenuOpen(false)}>AI - Artificial Intelligence</a></li>
              <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact & Support</a></li>
            </ul>
          </div>
        </div>
      </div>
      <aside className="dash-nav-sidebar">
        <div className="sidebar">
          <header>
            <img src={LogoImg} alt='img' />
            <div className='contact-info-cont'>
              <p>Contact Info We are open between 10 am to 6 pm from Monday to Saturday. Please reach us.</p>
              <ul>
                <li><span><GrLocation /></span> 14 A, 2nd Floor, Ramakrishna Nagar, New Siddhapudur, Coimbatore, Tamil Nadu, Pin : 641 044.</li>
                <li><a href='mailto:contact@bwefinserv.com' target='_blank' rel="noreferrer"><MdMailOutline /> contact@bwefinserv.com</a></li>
                <li><a href='tel:9500629337' target='_blank' rel="noreferrer"><MdOutlinePhone /> 95006 29337</a></li>
              </ul>
            </div>
          </header>
          <nav className="sidebar-nav-link">
            <ul>
              <li>
                <a href="#home" className={activeSection === 'home' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'home' ? 'active' : ''}`}></span> Home
                </a>
              </li>
              <li>
                <a href="#about" className={activeSection === 'about' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'about' ? 'active' : ''}`}></span> About Us
                </a>
              </li>
              <li>
                <a href="#productsAndServices" className={activeSection === 'productsAndServices' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'productsAndServices' ? 'active' : ''}`}></span> Products & Services
                </a>
              </li>
              <li>
                <a href="#solutions" className={activeSection === 'solutions' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'solutions' ? 'active' : ''}`}></span> Solutions
                </a>
              </li>
              <li>
                <a href="#pricing" className={activeSection === 'pricing' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'pricing' ? 'active' : ''}`}></span> Pricing
                </a>
              </li>
              <li>
                <a href="#resources" className={activeSection === 'resources' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'resources' ? 'active' : ''}`}></span> Resources
                </a>
              </li>
              <li>
                <a href="#securityAndCompliance" className={activeSection === 'securityAndCompliance' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'securityAndCompliance' ? 'active' : ''}`}></span> Security & Compliance
                </a>
              </li>
              <li>
                <a href="#ai" className={activeSection === 'ai' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'ai' ? 'active' : ''}`}></span> AI - Artificial Intelligence
                </a>
              </li>
              <li>
                <a href="#contact" className={activeSection === 'contact' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'contact' ? 'active' : ''}`}></span> Contact & Support
                </a>
              </li>
            </ul>
          </nav>
          <footer>
            <ul className="socials">
              <li><a href="/"><FaFacebookF /></a></li>
              <li><a href="/"><FaTwitter /></a></li>
              <li><a href="/"><FaPinterestP /></a></li>
              <li><a href="/"><FaLinkedinIn /></a></li>
            </ul>
          </footer>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;